/**
 * Forceert een vastzittende client naar de nieuwste versie.
 *
 * Een simpele reload is niet genoeg: zolang een oude service worker de controle
 * heeft, serveert die de pagina opnieuw uit zijn eigen precache. Daarom eerst
 * de registratie laten bijwerken -- de nieuwe worker roept zelf skipWaiting() en
 * neemt via clientsClaim over. Voor een op het beginscherm geinstalleerde PWA is
 * dit de enige uitweg: daar is geen adresbalk en geen verversknop.
 */
export async function applyAppUpdate(): Promise<void> {
  try {
    const registration = await navigator.serviceWorker?.getRegistration()
    if (registration) await registration.update()
  } catch {
    // Geen service worker of update geblokkeerd: de reload hieronder is dan
    // alsnog de beste poging.
  }
  window.location.reload()
}
